import Tabs from 'app/components/tabs/Index'

export default ({ defaultTabKey, ...props }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const setTabKey = useCallback((key) => {
    if (key != defaultTabKey) return setSearchParams({ tab: key })

    searchParams.delete('tab')
    setSearchParams(searchParams)
  })

  const tabKey = searchParams.get('tab')

  return (
    <Tabs {...props} tabKey={tabKey || defaultTabKey} setTabKey={setTabKey} />
  )
}
